"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WYRE_WIRE_REGEX = exports.WYRE_WIRE_COUNTRIES = exports.WYRE_WIRE_SEPA_NON_EUROZONE_COUNTRIES = exports.WYRE_WIRE_SEPA_EUROZONE_COUNTRIES = exports.DEBIT_FEES = exports.EXTERNAL_FEE_PERCENTAGE = exports.DIRECT_BUY_VARIABLE_FEE = exports.getDirectBuyVariableFee = exports.DIRECT_SELL_VARIABLE_FEE = exports.DIRECT_SELLS_MAX_IN_USD = exports.DIRECT_SELLS_MIN_AMOUNTS_IN_USD = exports.DIRECT_SELLS_MIN_AMOUNTS = exports.DIRECT_RATE_ACCEPTED_CURRENCIES = exports.DIRECT_WIRE_PAYOUT_ACCEPTED_CURRENCIES = exports.CRYPTO_BUY_SELL_SERVICE_COMMISSION_PERCENTAGE = exports.CRYPTO_BUY_SELL_FIXED_FEE = exports.getWyreFixedRate = exports.WYRE_FIXED_RATE = exports.DIRECT_CRYPTO_CURRENCIES = exports.ACCEPTED_CURRENCIES = void 0;
/* Wyre constants */
/** @deprecated in favor of GET PORYGON2_URL/currencies/details */
exports.ACCEPTED_CURRENCIES = ['ETH', 'BTC', 'DAI', 'SUSDC', 'XLM', 'BUSD', 'USDT', 'USDC'];
/** @deprecated in favor of GET PORYGON2_URL/currencies/details */
exports.DIRECT_CRYPTO_CURRENCIES = [
    // eth based
    'airtm:crypto:busd:busd-erc20', //forked from BUSD
    'airtm:crypto:dai',
    'airtm:crypto:ethereum',
    'airtm:crypto:tether:tether-erc20', // forked from tether
    'airtm:crypto:usdc',
    // stellar based
    'airtm:crypto:stellar-lumens',
    'airtm:crypto:susdc',
    // others
    'airtm:crypto:bitcoin',
];
exports.WYRE_FIXED_RATE = 1.0025;
/**
 * more information on
 * https://airtech.atlassian.net/wiki/spaces/M2/pages/2153218114/Fee+Structure
 * @deprecated in favor of GET PORYGON2_URL/currencies/details
 */
const getWyreFixedRate = (currency) => {
    const zeroFeeCurrencies = ['BUSD', 'SUSDC', 'USDC'];
    const reducedFees = ['DAI', 'USDT'];
    // add custom wyre fixed rates here
    if (zeroFeeCurrencies.includes(currency)) {
        return 1;
    }
    else if (reducedFees.includes(currency)) {
        return 1.001;
    }
    return exports.WYRE_FIXED_RATE;
};
exports.getWyreFixedRate = getWyreFixedRate;
/** @deprecated in favor of GET PORYGON2_URL/currencies/details */
exports.CRYPTO_BUY_SELL_FIXED_FEE = {
    // eth based
    BUSD: 0,
    DAI: 0,
    ETH: 0,
    USDC: 0,
    USDT: 0,
    // stellar based
    SUSDC: 0,
    XLM: 0,
    // others
    BTC: 0,
};
/** @deprecated in favor of GET PORYGON2_URL/currencies/details */
exports.CRYPTO_BUY_SELL_SERVICE_COMMISSION_PERCENTAGE = {
    // eth based
    BUSD: 0,
    DAI: 0,
    ETH: 0,
    USDC: 0,
    USDT: 0,
    // stellar based
    SUSDC: 0,
    XLM: 0,
    // others
    BTC: 0,
};
/**
 * Direct Wyre wire payouts
 * @deprecated in favor of GET PORYGON2_URL/currencies/details
 */
exports.DIRECT_WIRE_PAYOUT_ACCEPTED_CURRENCIES = ['GBP', 'EUR', 'AUD'];
/**
 * Direct operations constants
 * Direct must support quotes from USDs also.
 * @deprecated in favor of GET PORYGON2_URL/currencies/details
 */
exports.DIRECT_RATE_ACCEPTED_CURRENCIES = [
    // eth based
    'BUSD',
    'DAI',
    'ETH',
    'USD',
    'USDC',
    'USDT',
    // stellar based
    'SUSDC',
    'XLM',
    // others
    'BTC',
];
/**
 * it controls the minimun allowed for Direct Sell (Withdrawals)
 * @deprecated in favor of GET PORYGON2_URL/currencies/details
 */
exports.DIRECT_SELLS_MIN_AMOUNTS = {
    // eth based
    BUSD: 1,
    DAI: 5,
    ETH: 0.02,
    USD: 25,
    USDC: 1,
    USDT: 1,
    // stellar based
    SUSDC: 1,
    XLM: 1,
    // others
    BTC: 0.001,
};
/**
 * it controls the minimun allowed for Direct Sell (Withdrawals)
 * @deprecated in favor of GET PORYGON2_URL/currencies/details
 */
exports.DIRECT_SELLS_MIN_AMOUNTS_IN_USD = {
    // eth based
    BUSD: 25,
    DAI: 25,
    ETH: 25,
    USD: 25,
    USDC: 25,
    USDT: 25,
    // stellar based
    SUSDC: 1,
    XLM: 1,
    // others
    BTC: 25,
};
exports.DIRECT_SELLS_MAX_IN_USD = {
    UNVERIFIED: 200,
    VERIFIED: 1800,
};
/** @deprecated in favor of GET PORYGON2_URL/currencies/details */
exports.DIRECT_SELL_VARIABLE_FEE = {
    USD: {
        BTC: { exchangeFee: 0.65, withdrawFee: 0.6 },
        ETH: { exchangeFee: 0.65, withdrawFee: 0.6 },
        DAI: { exchangeFee: 0.65, withdrawFee: 0.6 },
        XLM: { exchangeFee: 0.65, withdrawFee: 0.6 },
        SUSDC: { exchangeFee: 0, withdrawFee: 0.6 },
        BUSD: { exchangeFee: 0.4, withdrawFee: 0.6 },
        USDC: { exchangeFee: 0.4, withdrawFee: 0.6 },
        USDT: { exchangeFee: 0.5, withdrawFee: 0.6 },
    },
    BTC: {
        BTC: { exchangeFee: 0, withdrawFee: 0.5 },
        ETH: { exchangeFee: 1.1, withdrawFee: 0.5 },
        DAI: { exchangeFee: 1.1, withdrawFee: 0.5 },
        XLM: { exchangeFee: 1.1, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 1.1, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 1.1, withdrawFee: 0.5 },
        USDC: { exchangeFee: 1.1, withdrawFee: 0.5 },
        USDT: { exchangeFee: 1.1, withdrawFee: 0.5 },
    },
    ETH: {
        BTC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0.83, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0.83, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0.83, withdrawFee: 0.5 },
    },
    DAI: {
        BTC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0.83, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0.83, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0.83, withdrawFee: 0.5 },
    },
    XLM: {
        BTC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0.83, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0.83, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0.83, withdrawFee: 0.5 },
    },
    SUSDC: {
        BTC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0.83, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0.83, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0.83, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0.83, withdrawFee: 0.5 },
    },
    BUSD: {
        BTC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0.83, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0.83, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0.83, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0.83, withdrawFee: 0.5 },
    },
    USDT: {
        BTC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0.83, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0.83, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0.83, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0.83, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0, withdrawFee: 0.5 },
    },
    USDC: {
        BTC: { exchangeFee: 0.5, withdrawFee: 0.5 },
        ETH: { exchangeFee: 0.5, withdrawFee: 0.5 },
        DAI: { exchangeFee: 0.5, withdrawFee: 0.5 },
        XLM: { exchangeFee: 0.5, withdrawFee: 0.5 },
        SUSDC: { exchangeFee: 0.5, withdrawFee: 0.5 },
        BUSD: { exchangeFee: 0.5, withdrawFee: 0.5 },
        USDT: { exchangeFee: 0.5, withdrawFee: 0.5 },
        USDC: { exchangeFee: 0, withdrawFee: 0.5 },
    },
};
function getDirectBuyVariableFee(acceptedCurrencies) {
    const pairCurrencies = ['USD', ...acceptedCurrencies];
    const getPairExchangeFee = (curr) => {
        return pairCurrencies.reduce((prev, aPairCurr) => {
            return Object.assign(prev, {
                [aPairCurr]: { exchangeFee: aPairCurr === curr ? 0 : 1 },
            });
        }, {});
    };
    const mainCurrencyReducer = (prev, curr) => {
        return Object.assign(prev, { [curr]: getPairExchangeFee(curr) });
    };
    return acceptedCurrencies.reduce(mainCurrencyReducer, {});
}
exports.getDirectBuyVariableFee = getDirectBuyVariableFee;
/** @deprecated in favor of GET PORYGON2_URL/currencies/details */
exports.DIRECT_BUY_VARIABLE_FEE = getDirectBuyVariableFee(exports.ACCEPTED_CURRENCIES);
// External Transfers
exports.EXTERNAL_FEE_PERCENTAGE = 1.002;
// Debit
exports.DEBIT_FEES = {
    VARIABLE: {
        USA: 2.9,
        INTERNATIONAL: 3.9,
    },
    FIXED: 0.3,
    MINIMUM: 5,
};
exports.WYRE_WIRE_SEPA_EUROZONE_COUNTRIES = [
    'austria',
    'belgium',
    'cyprus',
    'estonia',
    'finland',
    'france',
    'germany',
    'greece',
    'ireland',
    'italy',
    'latvia',
    'lithuania',
    'luxembourg',
    'malta',
    'netherlands',
    'portugal',
    'slovakia',
    'slovenia',
    'spain',
];
exports.WYRE_WIRE_SEPA_NON_EUROZONE_COUNTRIES = [
    'bulgaria',
    'croatia',
    'czech-republic',
    'denmark',
    'hungary',
    'iceland',
    'liechtenstein',
    'norway',
    'poland',
    'romania',
    'sweden',
    'switzerland',
];
exports.WYRE_WIRE_COUNTRIES = [
    ...exports.WYRE_WIRE_SEPA_EUROZONE_COUNTRIES,
    ...exports.WYRE_WIRE_SEPA_NON_EUROZONE_COUNTRIES,
    'united-kingdom',
    'australia',
];
exports.WYRE_WIRE_REGEX = new RegExp(['^airtm:bank:(', exports.WYRE_WIRE_COUNTRIES.join('|'), ')(-direct-withdraw)?'].join(''));
